"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var useDefaultValue = function useDefaultValue(onChange, _ref) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue;
  (0, _react.useEffect)(function () {
    if (defaultValue && value === undefined) {
      onChange(defaultValue);
    }
  }, []);
};

var _default = useDefaultValue;
exports["default"] = _default;